"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=require("@material-ui/core");let b=a.makeStyles(()=>({grid:{overflow:"hidden"},textOverflowTooltip:{overflow:"hidden",textOverflow:"ellipsis"}}));exports.default=b
//# sourceMappingURL=styles.js.map
